<template>
  <section>
    <p v-if="displayError" class="error-box"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>{{ displayError }}</p>
    <div v-if="isLoading" class="loading-spinner">
      <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
    </div>
    <div v-for="(netdev, index) in netdevices" :key="index">
      <netdevice
        :devmeta="netdev"
        :recurrentServicesInternet="recurrentServicesInternet"
        v-on:reload-nodes="loadNodes()"
        v-on:remove-device-from-view="netdevices.splice(index,1)"
      />
    </div>
    <section v-if="!isLoading && netdevices.length == 0">
      <div class="alert alert-info" role="alert">
        žádná registrovaná koncová zařízení
      </div>
    </section>

    <section v-if="$store.state.customerInfo && netdevices && haveAtLeast1InternetService && netdevices.length < $store.state.customerInfo['maxnodes1']">
      <div v-if="!$store.state.newMacDetected">
        <button class="btn btn-outline-primary add" v-on:click="addNetDevice()">
          <span><i class='fa fa-plus-square-o'></i> &nbsp; </span>
          <span class='add-label'>Připojit další koncové zařízení</span>
        </button>
      </div>
      <div v-else>
        <button class="btn btn-outline-primary add" v-on:click="addNetDevice($store.state.newMacDetected)">
          <span><i class='fa fa-plus-square-o'></i> &nbsp; </span>
          <span class='add-label'>Připojit další koncové zařízení s MAC adresou {{$store.state.newMacDetected}}</span>
        </button>
      </div>
    </section>
    <p>&nbsp;</p>
  </section>
</template>

<script>
import NetDeviceResource from '../backend-resources/netdevice-resource'
import NetDevice from '@/components/NetDevice'
import AssignmentResource from '../backend-resources/assignment-resource'

export default {
  data () {
    return {
      netdevices: null,
      displayError: null,
      isLoading: false,
      recurrentServicesInternet: null
    }
  },
  created: function () {
    this.loadNodes()
    this.loadServices()
  },
  components: {
    netdevice: NetDevice
  },
  methods: {
    loadNodes: function () {
      this.isLoading = true
      NetDeviceResource.get().then((devices) => {
        this.netdevices = devices.data
        this.displayError = null
        this.isLoading = false
      }).catch((error) => {
        this.displayError = error.response.status + ' ' + error.response.statusText
        this.netdevices = null
        this.isLoading = false
      })
    },
    addNetDevice: function (newMac) {
      this.netdevices.push({
        isNew: true,
        mac: newMac
      })
    },
    numDevices: function () {
      // Pokud je v poli rozeditovane jeste neulozene zarizeni, nepocitat
      return this.netdevices.filter(function (n) { return n.id > 0 }).length
    },
    loadServices () {
      AssignmentResource.get().then((services) => {
        let recurrentServices = services.data.recurrent
        this.recurrentServicesInternet = recurrentServices.filter(function (s) { return s['techtype'] === 71 }) // filter out non-internet
      }).catch(() => {
        this.recurrentServicesInternet = null
      })
    }
  },
  computed: {
    haveAtLeast1InternetService () {
      return this.recurrentServicesInternet && this.recurrentServicesInternet.length > 0
    }
  }
}
</script>
<style scoped>
netdevice {
  padding-left: 0;
  margin-left: 0;
}
.add {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// MyNetDevices.vue?17061a3c